import { Card, Form, Steps, Button, Row, Col, Modal, Select, Table, notification, InputNumber, Input } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import PageHeaderWrapper from '../../../components/PageHeaderWrapper';
// import GetAllFormFields from "../../../components/_utils/formUtils";
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import Request, { API_URL, LAPI_URL } from '../../../request';
import _, { get } from 'lodash';
import moment from 'moment';
import { hideLoader, showLoader } from '../../../modules/actions'
let localUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
const { Option } = Select;

const { Step } = Steps;


const filesStatusList = [
    { id: '1st Counselling Done', display: '1st Counselling Done' },
    { id: 'Final Counselling Done', display: 'Final Counselling Done' },
    { id: 'Enrollment Done', display: 'Enrollment Done' },
    { id: 'Shared Documents Checklist', display: 'Shared Documents Checklist' },
    { id: 'Documents Pending', display: 'Documents Pending' },
    { id: 'Documents Received', display: 'Documents Received' },
    { id: 'File Preparation', display: 'File Preparation' },
    { id: 'Verification Done by Client', display: 'Verification Done by Client' },
    { id: 'Final Visa File Review', display: 'Final Visa File Review' },
    { id: 'Pending Fees Received', display: 'Pending Fees Received' },
    { id: 'Visa File Submission', display: 'Visa File Submission' }
]
const visaStatusList = [
    { id: 'VISA_APPROVED', display: 'Visa Approved' },
    { id: 'Visa Refused', display: 'Visa Refused' },
    { id: 'Visa Waiting', display: 'Visa Waiting' }
]
@Form.create()
class AddVisaEnquiry extends React.Component {
    state = {
        id: null,
        dealingPhoneCodes: [],
        loyalityreffer: false,
        allLoyalityMembers: [],
        countryFieldArr: [],
        current: 0,
        phoneCodes: [],
        showApplicantModal: false,
        applicantsList: [],
        fileStatus: null,
        fileStatusFinal: null,
        visitorVisaTypes: [],
        allUsers: [],
        formData: {},
        showOtpField: false,
        mobile: null,
        isOtpVerified: false,
        allUsers: [],
        visaUsers: [],
        registrationUsers: [],
        type: null
    }

    handleSubmit = (e) => {
        let { form, dispatch } = this.props;
        let { id } = this.state;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            dispatch(showLoader())
            let finalData = { ...this.state.formData, ...values };
            finalData.fileStatus = this.state.fileStatus;
            finalData.applicants = this.state.applicantsList;
            this.setState({ loading: true });
            let response
            if (id) {
                finalData._id = id;
                response = await Request.editVisaEnquiry(finalData);
            } else {
                response = await Request.addVisaEnquiry(finalData);
                form.resetFields();
                this.setState({ current: 0 })
            }
            this.setState({ loading: false });

            dispatch(hideLoader())
            if (response.success) {
                notification.success({
                    message: response.message
                })

                setTimeout(() => {
                    window.location.href = '/visaEnquiry/all';
                }, 100)

            } else {
                notification.error({
                    message: response.message
                })
            }
        })
    }

    getVisitorVisaTypes = async () => {
        let params = {
            results: 100,
            count: 100
        }
        let response = await Request.getAllVisitorVisaType(params);
        let visitorVisaTypes = []
        _.each(response.data, (item) => {
            visitorVisaTypes.push({ id: item._id, display: item.visitorVisaType })
        })

        this.setState({ visitorVisaTypes })
    }


    getVisitorVisaCounsellors = async () => {
        let params = {
            sortField: '_id',
            sortOrder: 'ascend',
            results: 200,
            active: true,
            userBranch: localUser.userBranch,
            userType: { $ne: "Student" },
            isVisitorVisaCounsellor: true
        }
        let response = await Request.loadUser({ ...params, regExFilters: ['name'] })
        let userArray = [];
        response.data.map((user, index) => {
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({ allUsers: userArray })
    }

    setFormValues = async (visaEnquiryId) => {
        try {
            Request.getVisaEnquiryDetail({ _id: visaEnquiryId }).then(({ data, error }) => {
                if (!error) {
                    // this.setState({
                    //     fileStatus: data && data.fileStatus,
                    //     fileStatusFinal: data && data.fileStatus,
                    //     visaDate: data && moment(data.visaApprovalDate).format('YYYY-MM-DD')
                    // });

                    // if (data && data.visaStatus === 'Visa Approved') {
                    //     this.setState({ visibleApprovalDate: true })
                    // } else {
                    //     this.setState({ visibleApprovalDate: false })
                    // }
                    if (data && data.type) {
                        let selected = this.state.visitorVisaTypes.find(o => o.id === data.type);
                        this.setState({ type: selected.display });
                    }


                    this.setState({
                        formData: data,
                        applicantsList: data.applicants ? data.applicants : [],
                        fileStatus: data && data.fileStatus
                    }, () => {
                        // Setting values in the form
                        this.props.form.setFieldsValue({
                            // Basic Details Step (Step 0)
                            applicantName: data && data.applicantName,
                            dateOfBirth: data.dateOfBirth ? moment(data.dateOfBirth) : null,
                            address: data && data.address,
                            mobileNumber: data && data.mobileNumber,
                            landlineNumber: data && data.landlineNumber,
                            noOfPeopleApplying: data && data.noOfPeopleApplying,
                            type: data && data.type,
                            namesAndRelationship: data && data.namesAndRelationship,
                            country: data && data.country,
                            longYears: data && data.longYears,
                            countryCode: data && data.countryCode,
                            knowAnyone: data && data.knowAnyone,
                            relationWithPerson: data && data.relationWithPerson,
                            immigrationStatus: data && data.immigrationStatus,
                            occupation: data && data.occupation,
                            annualIncome: data && data.annualIncome,
                            financialWorth: data && data.financialWorth,
                            counsellorComments: data && data.counsellorComments,
                            eligible: data && data.eligible,
                            fileStatus: data && data.fileStatus,
                            enquiryStatus: data && data.enquiryStatus,
                            submissionDate: data && data.submissionDate ? moment(data.submissionDate) : null,
                            fileNo: data && data.fileNo,
                            visaStatus: data && data.visaStatus,
                            time: data && data.time,
                            source: data && data.source,
                            // Additional Applicants Step (Step 1)
                            applicants: data && data.applicants || [],
                            registrationUserId: data && data.registrationUserId,
                            // Agreements & Process Step (Step 2)
                            agreementSigned: data && data.agreementSigned,
                            processStatus: data && data.processStatus,
                            additionalComments: data && data.additionalComments,
                            parentCountryCode: data && data.parentCountryCode,
                            visaUserId: data && data.visaUserId,
                        });

                        // Set value for counsellorId only on Step 2
                        if (this.state.current === 2) {
                            this.props.form.setFieldsValue({
                                counsellorId: data.counsellorId || '',
                                agreement: data.agreement || [],
                                visaUserId: data.visaUserId || '',
                                registrationUserId: data.registrationUserId || ''

                            });
                        }
                    });
                }
            });
        } catch (e) {
            console.log(e);
        }
    };


    setFormValuess = async (visaEnquiryId) => {
        try {

            Request.getVisaEnquiryDetail({ _id: visaEnquiryId }).then(({ data, error, message }) => {
                if (!error) {

                    this.setState({
                        id: data._id,
                        formData: data
                    });
                    // this.props.form.setFieldsValue(data);

                    this.setState({
                        fileStatus: data && data.fileStatus,
                        fileStatusFinal: data && data.fileStatus,
                        visaDate: data && moment(data.visaApprovalDate).format('YYYY-MM-DD')
                    });

                    if (data && data.visaStatus === 'Visa Approved') {
                        this.setState({ visibleApprovalDate: true })
                    } else {
                        this.setState({ visibleApprovalDate: false })
                    }

                    if (data && data.applicants) {
                        this.setState({ applicantsList: data.applicants });
                    }

                    if (data && data.type) {
                        let selected = this.state.visitorVisaTypes.find(o => o.id === data.type);
                        this.setState({ type: selected.display });
                    }

                    this.props.form.setFieldsValue({
                        applicantName: data && data.applicantName,
                        dateOfBirth: data && moment(data.dateOfBirth),
                        address: data && data.address,
                        mobileNumber: data && data.mobileNumber,
                        landlineNumber: data && data.landlineNumber,
                        noOfPeopleApplying: data && data.noOfPeopleApplying,
                        type: data && data.type,
                        namesAndRelationship: data && data.namesAndRelationship,
                        country: data && data.country,
                        longYears: data && data.longYears,
                        countryCode: data && data.countryCode,
                        knowAnyone: data && data.knowAnyone,
                        relationWithPerson: data && data.relationWithPerson,
                        immigrationStatus: data && data.immigrationStatus,
                        occupation: data && data.occupation,
                        annualIncome: data && data.annualIncome,
                        financialWorth: data && data.financialWorth,
                        counsellorComments: data && data.counsellorComments,
                        eligible: data && data.eligible,
                        fileStatus: data && data.fileStatus,
                        enquiryStatus: data && data.enquiryStatus,
                        submissionDate: data && moment(data.submissionDate),
                        fileNo: data && data.fileNo,
                        visaStatus: data && data.visaStatus,
                        time: data && data.time,
                        counsellorId: data && data.counsellorId,
                        visaUpload: data && data.visaUpload,
                        uploadDate: data && moment(data.uploadDate),
                        visaApprovalDate: data && moment(data.visaApprovalDate),
                        passportNo: data && data.passportNo,
                        source: data && data.source,
                        parentCountryCode: data && data.parentCountryCode,
                        registrationUserId: data && data.registrationUserId,
                        visaUserId: data && data.visaUserId
                    });

                } else {
                    notification.error({
                        message: 'Error Getting Data',
                        description: message
                    })
                }
            })

        } catch (e) {
            console.log(e)
        }
    }

    addPaymentStep = () => {
        console.log();
    }

    getVisaUsers = async () => {
        let localUser = JSON.parse(localStorage.getItem("user"));
        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            isVisa: true,
            active: true,
            userBranch: localUser ? localUser.userBranch : null,
        });
        let visaUsers = allUsers.reduce((temp, vv) => {
            temp.push({
                _id: vv._id,
                display: vv.name
            });
            return temp;
        }, [])
        this.setState({ visaUsers, localUser: localUser });
    }


    getRegistrationUsers = async () => {
        let localUser = JSON.parse(localStorage.getItem("user"));
        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            isRegistration: true,
            active: true,
            userBranch: localUser ? localUser.userBranch : null,
        });
        let registrationUsers = allUsers.reduce((temp, vv) => {
            temp.push({
                _id: vv._id,
                display: vv.name
            });
            return temp;
        }, [])
        this.setState({ registrationUsers, localUser: localUser });
    }

    async componentDidMount() {
        this.loadCountries();
        this.getVisitorVisaTypes();
        this.getVisitorVisaCounsellors();
        this.getVisaUsers();
        this.getRegistrationUsers();
        const { dispatch } = this.props;
        let searchParams = new URLSearchParams(this.props.search)
        let visaEnquiryId = searchParams.get('id');
        this.setState({
            id: visaEnquiryId
        });
        dispatch(showLoader())
        if (visaEnquiryId) {
            this.addPaymentStep()
            setTimeout(() => {
                this.setFormValues(visaEnquiryId);
            }, 1500);
        }
        dispatch(hideLoader())
    }

    loadCountries = () => {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
        };
        Request.getCountriesWithoutAuth({ ...params })
            .then((resp) => {
                let countryFieldArr = [];
                let phoneCodes = [];
                let countryPhoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    countryFieldArr.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        countryPhoneCodes[vv._id] = vv.countryPhoneCode;
                        phoneCodes.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode });
                    }
                    temp.push({ ...vv });
                    return temp;
                }, []);
                this.setState({ countryFieldArr: countryFieldArr, phoneCodes: phoneCodes, countryPhoneCodes: countryPhoneCodes });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    next() {
        const { form } = this.props;
        const { id, current, formData } = this.state;
        if (this.state.isOtpVerified == false && !this.state.id) {
            return notification.error({
                message:
                    "Mobile number is not verified, Please verify.",
            });
        }
        if (current === 1) {
            setTimeout(() => {
                formData['submissionDate'] = formData.submissionDate ? moment(formData.submissionDate) : null;
                formData.visaDate = formData && formData.visaDate ? moment(formData.visaDate) : null;
                this.props.form.setFieldsValue(formData);
            }, 50)
            this.setState(prevState => ({
                current: prevState.current + 1
            }));
        } else if (current === 2 && formData.counsellorId) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    counsellorId: formData && formData.counsellorId
                })
            }, 50)
        } else {
            form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    this.setState(prevState => ({
                        formData: { ...prevState.formData, ...values },
                        current: prevState.current + 1
                    }));
                }
            });
        }
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current }, () => {
            this.props.form.setFieldsValue(this.state.formData);
        });
    }

    getLoyalityMembers() {

    }

    checkSendOtp = async (value, leadSource) => {
        let mobile = value.target.value;
        if (mobile) {
            const response = await Request.sendVisitorOtpOnMobile({ mobile, leadSource });
            // const response = await Request.sendOTPOnMobile({ mobile });
            if (response && response.OtpSent == true) {
                this.setState({ showOtpField: true, mobile });
                return notification.success({
                    message: "Welcome Code Sent.",
                });
            } else {
                return notification.warning({
                    message: response.msg,
                });
            }
        }
    }

    verifyOTP = async (e) => {
        const response = await Request.verifyOTP({ mobile: this.state.mobile, otpValue: e.target.value });
        if (response && response.OtpVerified == true) {
            this.setState({ isOtpVerified: true, showOtpField: false });
            return notification.success({
                message: "Otp verified.",
            });
        } else {
            return notification.error({
                message: response.message,
            });
        }
    }

    handleReferenceSubmit = () => {
        let { form } = this.props;
        let applicantFromValues = form.getFieldsValue(['additionalApplicantName', 'applicantCountryCode', 'applicantMobile', 'relationWithApplicant'])
        if (!applicantFromValues.additionalApplicantName) {
            notification.error({
                message: 'Expect Applicant Name!'
            })
            return
        }
        if (!applicantFromValues.applicantCountryCode) {
            notification.error({
                message: 'Expect Applicant Country Code!'
            })
            return
        }
        if (!applicantFromValues.applicantMobile) {
            notification.error({
                message: 'Expect Applicant Mobile Number!'
            })
            return
        }
        if (!applicantFromValues.relationWithApplicant) {
            notification.error({
                message: 'Expect Relation With Main Applicant!'
            })
            return
        }
        let applicantsList = this.state.applicantsList
        applicantsList.push(applicantFromValues)
        this.setState({ applicantsList, showApplicantModal: false }, () => {
            this.props.form.setFieldsValue({
                additionalApplicantName: null,
                applicantCountryCode: null,
                applicantMobile: null,
                relationWithApplicant: null
            })
        });

    }

    render() {
        let { id, dealingPhoneCodes, visaUsers, registrationUsers, phoneCodes, allUsers, loyalityreffer, allLoyalityMembers, countryFieldArr, current, visitorVisaTypes } = this.state;
        let { form: { setFieldsValue, getFieldDecorator } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Applicant Name',
                    key: 'applicantName',
                    required: true,
                    style: { width: 300 }
                },
                {
                    label: 'Date Of Birth',
                    key: 'dateOfBirth',
                    type: 'date',
                    required: true,
                    style: { width: 300 },
                    customProps: {
                        disabledDate: d => !d || d.isSameOrAfter(moment(), 'day'),
                    }
                },
                {
                    label: 'Address',
                    key: 'address',
                    type: 'textarea',
                    required: true,
                },
                {
                    label: 'Source',
                    key: 'source',
                    type: 'select',
                    options: ["Direct", "Sub Agent", "Loyality Program"],
                    required: true,
                    onChange: v => {
                        setFieldsValue({ source: v })
                        if (v === "Loyality Program") {
                            this.setState({ loyalityreffer: true })
                            this.getLoyalityMembers()
                        } else {
                            this.setState({ loyalityreffer: false })
                        }
                    }
                },
                {
                    label: 'Country Code',
                    key: 'countryCode',
                    type: 'select',
                    style: { width: 200 },
                    showSearch: true,
                    required: true,
                    options: phoneCodes,
                    onChange: v => {
                        setFieldsValue({ countryCode: v })
                    }
                },
                {
                    label: 'Mobile Number',
                    key: 'mobileNumber',
                    type: 'number',
                    required: true,
                    style: { width: 200 },
                    onBlur: v => {
                        let leadSource = this.props.form.getFieldValue('source');
                        if (!this.state.id) {
                            this.checkSendOtp(v, leadSource);
                        }
                    },
                    rightComp: (
                        <div>
                            {
                                this.state.showOtpField ?
                                    <Button
                                        style={{ marginLeft: "3px" }}
                                        type="primary"
                                        onClick={() => {
                                            this.setState({
                                                showOtpField: false,
                                                isOtpVerified: true
                                            })
                                        }}
                                    >
                                        Skip
                                    </Button>
                                    : null
                            }
                        </div>
                    ),
                },
                {
                    label: "Enter Welcome Code",
                    key: "otp",
                    type: "number",
                    onBlur: v => {
                        this.verifyOTP(v);
                    },
                    required: this.state.showOtpField,
                    hidden: this.state.showOtpField ? false : true,
                    style: { width: 307 },
                    parser: (value) => value.substring(0, 10)
                },
                {
                    label: 'Parent Mobile Country Code',
                    key: 'parentCountryCode',
                    type: 'select',
                    style: { width: 200 },
                    showSearch: true,
                    required: true,
                    options: phoneCodes,
                    onChange: v => {
                        setFieldsValue({ parentCountryCode: v })
                    }
                },
                {
                    label: 'Parent\'s Mobile No',
                    key: 'landlineNumber',
                    type: 'number',
                    required: true,
                    style: { width: 200 }
                },

                {
                    label: 'Member Name',
                    key: 'membershipDetail',
                    type: 'select',
                    showSearch: true,
                    required: loyalityreffer ? true : false,
                    hidden: loyalityreffer ? false : true,
                    options: allLoyalityMembers,
                    onChange: v => {
                        setFieldsValue({ membershipDetail: v })
                    }
                },
                {
                    label: 'Which Country Applicant Wish to Visit?',
                    key: 'country',
                    type: 'select',
                    options: countryFieldArr,
                    showSearch: true,
                    required: true,
                    onChange: v => {
                        setFieldsValue({ country: v })
                    }
                },
                {
                    label: 'How long Applicant wish to visit?',
                    key: 'longYears',
                    required: true,
                    style: { width: 200 }
                },
                {
                    label: 'Do you know anyone there in that country?',
                    key: 'knowAnyone',
                    required: true
                },
                {
                    label: 'Relation with that person?',
                    key: 'relationWithPerson',
                    type: 'textArea',
                    required: true
                },
                {
                    label: 'What is the immigration status of the person you are going to visit?',
                    key: 'immigrationStatus',
                    required: true,
                    type: 'textArea'
                },
                {
                    label: 'What is your Occupation?',
                    key: 'occupation',
                    required: true,
                    type: 'textArea'
                },
                {
                    label: 'How much is your annual income?',
                    key: 'annualIncome',
                    required: true,
                    type: 'number',
                    style: { width: 200 }
                },
                {
                    label: 'How much is your financial worth?',
                    key: 'financialWorth',
                    required: true,
                    style: { width: 200 },
                    type: 'number'
                }
            ]
        };

        const inputSchema = {
            fields: [
                {
                    label: 'Upload Agreement',
                    key: 'agreement',
                    type: 'file'
                },
                {
                    label: 'Counsellor',
                    key: 'counsellorId',
                    required: true,
                    style: { width: 200 },
                    type: 'select',
                    options: this.state.allUsers,
                    onChange: v => {
                        this.props.form.setFieldsValue({ counsellorId: v })
                    }
                },
                {
                    label: 'Enrollment Status',
                    key: 'type',
                    required: true,
                    style: { width: 200 },
                    type: 'select',
                    options: visitorVisaTypes,
                    onChange: v => {
                        let selected = visitorVisaTypes.find(o => o.id === v);
                        this.setState({ type: selected.display });
                        this.props.form.setFieldsValue({ type: v })
                    }
                },
                {
                    label: 'Registration User',
                    key: 'registrationUserId',
                    hidden: this.state.type === 'Enrolled' ? false : true,
                    required: this.state.type === 'Enrolled' ? true : false,
                    style: { width: 200 },
                    type: 'select',
                    showSearch: true,
                    options: registrationUsers,
                    onChange: v => {
                        this.props.form.setFieldsValue({ registrationUserId: v })
                    }
                },
                {
                    label: 'Counsellor Comments',
                    key: 'counsellorComments',
                    required: (id ? true : false),
                    type: 'textArea'
                },
                {
                    label: 'File Status',
                    key: 'fileStatus',
                    required: true,
                    type: 'select',
                    options: filesStatusList,
                    hidden: (!id ? true : false),
                    onChange: (v) => {
                        this.setState({
                            fileStatus: v,
                            fileStatusFinal: v
                        });
                        this.props.form.setFieldsValue({ fileStatus: v })
                    }
                },
                {
                    label: 'Visa User',
                    key: 'visaUserId',
                    hidden: this.state.fileStatus === 'Enrollment Done' || this.state.fileStatus === 'Visa File Submission' ? false : true,
                    required: this.state.fileStatus === 'Enrollment Done' || this.state.fileStatus === 'Visa File Submission' ? true : false,
                    style: { width: 200 },
                    type: 'select',
                    showSearch: true,
                    options: visaUsers,
                    onChange: v => {
                        this.props.form.setFieldsValue({ visaUserId: v })
                    }
                },
                {
                    label: 'Submission Date',
                    key: 'submissionDate',
                    type: 'date',
                    required: true,
                    hidden: this.state.fileStatus === 'Visa File Submission' ? false : true
                },
                {
                    label: 'File No',
                    key: 'fileNo',
                    required: true,
                    placeholder: 'File No',
                    hidden: this.state.fileStatus === 'Visa File Submission' ? false : true
                },
                {
                    label: 'Visa Status',
                    key: 'visaStatus',
                    required: true,
                    type: 'select',
                    options: visaStatusList,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ visaStatus: v })
                        if (v === 'Visa Approved') {
                            this.setState({ visibleApprovalDate: true })
                        } else {
                            this.setState({ visibleApprovalDate: false })
                        }
                    },
                    hidden: this.state.fileStatus === 'Visa File Submission' ? false : true
                },
                {
                    label: 'Visa Approval Date',
                    key: 'visaApprovalDate',
                    type: 'date',
                    required: true,
                    hidden: !this.state.visibleApprovalDate || this.state.fileStatus !== 'Visa File Submission' ? true : false
                },
                {
                    label: 'Upload File',
                    key: 'visaUpload',
                    type: 'file',
                    hidden: this.state.fileStatus === 'Visa File Submission' ? false : true
                }
            ]
        }

        const newApplicantSchema = {
            fields: [
                {
                    label: 'Applicant Name',
                    key: 'additionalApplicantName',
                    required: true,
                },
                {
                    label: 'Country Code',
                    key: 'applicantCountryCode',
                    type: 'select',
                    options: phoneCodes,
                    showSearch: true,
                    required: true,
                    onChange: v => {
                        setFieldsValue({ applicantCountryCode: v })
                    }
                },
                {
                    label: 'Mobile Number',
                    key: 'applicantMobile',
                    required: true,
                    type: 'number',
                    style: { width: 240 }
                },
                {
                    label: 'Relation with Main Applicant?',
                    key: 'relationWithApplicant',
                    required: true,
                }
            ]
        }

        const applicantListColumns = [
            {
                title: 'Applicant Name',
                key: 'additionalApplicantName',
                dataIndex: 'additionalApplicantName',
            },
            {
                title: 'Applicant Mobile',
                key: 'applicantMobile',
                render: (text, record) => (
                    <div>{record.applicantCountryCode}-{record.applicantMobile}</div>
                )
            },
            {
                title: 'Relation With Main Applicant',
                key: 'relationWithApplicant',
                dataIndex: 'relationWithApplicant'
            }
        ]
        const steps = [
            {
                title: 'Basic Details',
                content: <>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={LAPI_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                    </Form>
                </>
            },
            {
                title: 'Additional Applicants',
                content: <>
                    <Card>
                        <div className={"applicantsItem"}>
                            <a onClick={() => this.setState({ showApplicantModal: true })}>Click to add</a>
                            <Modal
                                title="Applicant Details"
                                visible={this.state.showApplicantModal}
                                onCancel={() => this.setState({ showApplicantModal: false })}
                                onOk={() => this.setState({ showApplicantModal: false })}
                                footer={[<Button
                                    type="primary"
                                    onClick={() => this.handleReferenceSubmit()}
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>]}
                            >
                                <Form>
                                    <GetAllFormFields apiurl={LAPI_URL} inputSchema={newApplicantSchema} getFieldDecorator={getFieldDecorator} />
                                </Form>
                            </Modal>
                        </div>
                        <Row style={{ marginTop: 40 }}>
                            <Col span={24}>
                                <Table
                                    bordered={true}
                                    style={{ width: '100%' }}
                                    columns={applicantListColumns}
                                    dataSource={this.state.applicantsList}
                                    pagination={false}
                                />
                            </Col>
                        </Row>
                    </Card>
                </>
            },
            {
                title: 'Agreements & Process',
                content: <>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputSchema} apiurl={LAPI_URL} getFieldDecorator={getFieldDecorator} />
                    </Form>
                </>
            },
            // {
            //     title: 'Payment Details',
            //     content: <>

            //     </>
            // }
        ]
        return (
            <PageHeaderWrapper title={this.state.id ? 'Update Visa Enquiry' : 'New Visa Enquiry'}>
                <Card bordered={true}>
                    <Steps current={current}>
                        {steps.map(item => (
                            <Step status={this.state.stepsStatus} key={item.title} title={item.title} />
                        ))}
                    </Steps>
                    <div style={{ marginTop: 30 }} className='steps-content'>{steps[current].content}</div>
                    <div style={{ marginTop: 10 }} className='steps-action'>
                        {
                            current < steps.length - 1 && (
                                <Button type='primary' onClick={() => this.next()}>
                                    {current === 0 ? "Next" : "Save"}
                                </Button>
                            )}

                        {
                            current === steps.length - 1 && (
                                <Button type='primary' loading={this.state.loading} onClick={this.handleSubmit}>
                                    {id ? "Update" : "Done"}
                                </Button>
                            )
                        }


                        {/* {
                            current === steps.length - 1 && (
                                <Button type='primary' htmlType="submit">{id ? "Update" : "Done"}</Button>
                            )} */}
                        {
                            current > 0 && (
                                <Button style={{ marginLeft: 8 }} onClick={() => this.prev()}>
                                    Previous
                                </Button>
                            )}
                    </div>

                </Card>
                {/* <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} apiurl={API_URL} getFieldDecorator={getFieldDecorator} formItemLayout={{
                            labelCol: { span: 10 },
                            wrapperCol: { span: 12 }
                        }} />
                    </Form>
                </Card> */}
            </PageHeaderWrapper>
        )
    }
}


const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddVisaEnquiry)